import React, { Component } from 'react';
import { bool, func } from 'prop-types';
import cs from 'classnames';
import { Grid } from '@mui/material';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import { Button } from '../../../Button';

class DialogControls extends Component {
  static propTypes = {
    onVisibilityChange: func,
    templatesVisible: bool,
  };

  static defaultProps = {
    onVisibilityChange: () => {},
    templatesVisible: true,
  };

  shouldComponentUpdate(nextProps) {
    return this.props.templatesVisible !== nextProps.templatesVisible;
  }

  render() {
    return (
      <Grid container spacing={0} sx={{ pt: 1, pb: 1 }}>
        <Grid
          sx={{ display: 'flex', alignItems: 'center' }}
          size={{
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }}>
          <Button
            size="large"
            variant="text"
            iconLeft={
              <PlayCircleFilledIcon
                className={cs({ 'zmdi-hc-rotate-180': this.props.templatesVisible })}
                sx={{ mr: 0.5 }}
              />
            }
            labelId={`dialog.notices.templates.${this.props.templatesVisible ? 'hide' : 'show'}`}
            onClick={this.props.onVisibilityChange}
            className="toggle-templates-button"
            sx={{ mr: 2 }}
          />
        </Grid>
      </Grid>
    );
  }
}

export default DialogControls;
